import { render, staticRenderFns } from "./TrustCard.vue?vue&type=template&id=9ad73222&scoped=true"
import script from "./TrustCard.vue?vue&type=script&lang=js"
export * from "./TrustCard.vue?vue&type=script&lang=js"
import style0 from "./TrustCard.vue?vue&type=style&index=0&id=9ad73222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad73222",
  null
  
)

export default component.exports